<template>
    <section class="timeline">
        <h2>{{ $t('workflow.title') }}</h2>
        <div class="wrapper">
            <div class="center-line">
                <a href="#" class="scroll-icon"><i class="fas fa-caret-up"></i></a>
            </div>
            <div class="row" v-for="(step, index) in steps" :key="index">
                <section>
                    <i class="icon fas fa-star"></i>
                    <div class="details">
                        <span class="number">{{ step.number }}</span>
                        <span class="title">{{ $t(step.title) }}</span>
                    </div>
                    <div class="content-wrapper">
                        <p>{{ $t(step.description) }}</p>
                    </div>
                </section>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'TimelineWorkflow',
    data() {
        return {
            steps: [
                {
                    number: '01',
                    title: 'workflow.step1.title',
                    description: 'workflow.step1.description'
                },
                {
                    number: '02',
                    title: 'workflow.step2.title',
                    description: 'workflow.step2.description'
                },
                {
                    number: '03',
                    title: 'workflow.step3.title',
                    description: 'workflow.step3.description'
                },
                {
                    number: '04',
                    title: 'workflow.step4.title',
                    description: 'workflow.step4.description'
                },
                {
                    number: '05',
                    title: 'workflow.step5.title',
                    description: 'workflow.step5.description'
                },
                {
                    number: '06',
                    title: 'workflow.step6.title',
                    description: 'workflow.step6.description'
                }
            ]
        };
    }
}
</script>
